var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#98D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 8.49902L9.69992 17.5305C8.89992 17.1995 8.04992 17.1995 7.49992 17.6251C6.54992 18.3344 6.64992 19.8948 7.69992 21.1242C8.29992 21.8335 9.09992 22.2591 9.84992 22.3537L8.74992 30.0612L18.3999 31.9999L17.5999 26.1365C19.5499 26.3729 21.2999 24.9544 21.3999 23.1102L21.9499 11.3834L10.7499 8.49902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6002 12.6601C19.7502 13.8423 24.5002 15.8756 23.9502 11.3361C23.7502 9.82301 23.0502 8.40445 21.9002 7.31688C16.9002 2.58834 8.55024 5.99289 9.00024 9.30287C6.20024 11.6671 4.80024 14.6934 7.35024 17.8143C7.35024 17.8143 8.80024 16.5375 9.90024 17.8143C11.0002 19.091 12.6002 9.44473 12.6002 9.44473C12.6002 9.44473 12.6502 16.3484 15.8502 12.9439C16.2502 12.471 17.0002 12.3764 17.6002 12.6601Z",
    fill: "#3844DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21C16 21 16.7214 22.0658 18 21.9968",
    stroke: "#3843DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4,
    y1: 3.5,
    x2: 30,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D4DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2B1C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.c6679b9b23f6f7a8f43f5c8d163950d7.svg";
export { ForwardRef as ReactComponent };